import { Injectable } from '@angular/core';
import { Platform, App, ToastController } from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { Globals } from '../../globals';

@Injectable()
export class AIServices {

  // Ya no necesitamos headers con API keys (están seguras en el backend)
  headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  
  // For Image Generation
  model_img: string = 'gpt-image-1.5';

  // For LLMs (Language Models)
  model_llm_gpt4_turbo: string = 'gpt-4-turbo';
  model_llm_gpt4_1106: string = 'gpt-4-1106-preview';
  model_llm_gpt4o: string = 'gpt-4o';
  model_llm_gpt4_5_prev: string = 'gpt-4o'; // Cambiado de 'gpt-4.5-preview' (no existe) a 'gpt-4o'

  constructor(public app: App,
    public platform: Platform,
    private http: HttpClient,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public globals: Globals) {
  }

  async openAIGenerateImage(prompt) {
    //prepare body
    var body = {
      prompt: prompt,
      model: this.model_img,
      n: 1,
      size: '1024x1024',
      quality: 'high'
    };
    //call backend (que luego llama a OpenAI)
    return await this.http.post(this.globals.analytics_path + 'ai/generate-image-v2',
      body,
      {
        headers: this.headers
      }).toPromise();
  }

  async openAIGenerateText(response_format, messages, _timeout) {
    //prepare body
    const body = {
      model: this.model_llm_gpt4_5_prev,
      response_format: response_format,
      messages: messages,
      max_tokens: 6000
    }
    //call backend (que luego llama a OpenAI)
    var response = await this.http.post(this.globals.analytics_path + 'ai/generate-text',
      body,
      {
        headers: this.headers
      }).pipe(
        timeout(_timeout),
        catchError(error => {
          return throwError(error);
        })
      ).toPromise();
    return response;
  }

  async deepseekOpenAIGenerateText(response_format, messages) {
    // Prepare body for DeepSeek API
    const body = {
      model: "deepseek-chat", //deepseek-chat" - deepseek-reasoner
      messages: messages,
      temperature: 1.0,
      max_tokens: 6000,
      top_p: 0.8,
      frequency_penalty: 0.1,
      presence_penalty: 0.1,
      stream: false
    };

    // Add response_format only if it's provided
    if (response_format) {
      body['response_format'] = response_format;
    }
    
    try {
      // Call backend (que luego llama a DeepSeek)
      const response = await this.http.post(this.globals.analytics_path + 'ai/deepseek-text', body, {
        headers: this.headers
      }).pipe(
        catchError(error => {          
          // Handle specific error cases
          if (error && error.status === 401) {
            throw new Error('Authentication failed. Please check your API key.');
          } else if (error && error.status === 429) {
            throw new Error('Rate limit exceeded. Please try again later.');
          } else if (error && error.status === 400) {
            const errorMessage = error.error && error.error.message ? error.error.message : 'Unknown error';
            throw new Error(`Bad request: ${errorMessage}`);
          } else if (error && error.name === 'TimeoutError') {
            throw new Error('Request timed out. Please try again.');
          }
          
          const errorMessage = error && error.message ? error.message : 'Unknown error';
          throw new Error(`API call failed: ${errorMessage}`);
        })
      ).toPromise();
      return response;
    } catch (error) {
      const errorMessage = error && error.message ? error.message : 'Unknown error';
      throw new Error(`DeepSeek API call failed: ${errorMessage}`);
    }
  }

  async openAIGeneratePromptForDallE(input_text) {
    var messages = [
      { "role": "system", "content": "Eres un experto en crear prompts para DALL-E. Por favor, genera solo el texto del prompt en inglés, sin añadir ningún encabezado, introducción o comentario adicional." },
      { "role": "user", "content": "A partir de este texto: " + input_text + ", genera un prompt detallado en inglés para crear una imagen en DALL-E. El prompt debe ser lo suficientemente específico para que el modelo pueda entender y generar la imagen deseada sin ninguna ambigüedad. No añadas la frase 'Prompt para DALL-E:' ni ninguna otra introducción, solo el contenido del prompt." }
    ];

    // prepare body
    const body = {
      model: this.model_llm_gpt4o,
      messages: messages
    };

    // call backend (que luego llama a OpenAI)
    var response = await this.http.post(this.globals.analytics_path + 'ai/generate-text',
      body,
      {
        headers: this.headers
      }).toPromise();
    return response;
  }

  async openAIGenerateSuggestedPrice(response_format, messages, _timeout) {
    //prepare body
    const body = {
      model: this.model_llm_gpt4o,
      response_format: response_format,
      messages: messages
    }
    //call backend (que luego llama a OpenAI)
    var response = await this.http.post(this.globals.analytics_path + 'ai/generate-text',
      body,
      {
        headers: this.headers
      }).pipe(
        timeout(_timeout),
        catchError(error => {
          return throwError(error);
        })
      ).toPromise();
    return response;
  }
}


// WEBPACK FOOTER //
// ./src/pages/services/aiServices.ts